<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Auth from '@/libraries/auth.js';

export default {
  name: 'App',
  created() {
    if (!Auth.loggedIn() && this.$router.currentRoute.path !== '/login') {
      this.$router.push('/login');
    }
  },
};
</script>

<style lang="scss">
@charset "utf-8";
// Import Bulma's core
@import url('https://fonts.googleapis.com/css?family=Nunito:400,700');

$family-sans-serif: 'Nunito', sans-serif;
$body-font-size: 0.8em;

@import 'static/global.scss';

// Import Bulma and Buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

.columns {
  &.is-fullheight {
    min-height: calc(100vh - (#{$navbar-height} - 0.75rem));
    max-height: calc(100vh - (#{$navbar-height} - 0.75rem));
    height: calc(100vh - (#{$navbar-height} - 0.75rem));
    display: flex;
    flex-direction: row;
    justify-content: stretch;
  }
}

.navbar {
  border-bottom: $grey-light solid 1px;
  -webkit-box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.35);
  -moz-box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.35);
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.35);
  position: fixed;
  top: 0rem;
  width: 100%;
  z-index: 10;
}

.is-main-body {
  margin-top: 3.7rem;
  padding-right: 1.4rem;
}

.is-main-content {
  background: $white;
  padding-right: 1rem;
}

$section-head-border-color: #cfcfcf;
.section-head {
  border-bottom: 1px solid $section-head-border-color;
  padding-bottom: 0.25rem;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
  font-size: 2rem;
}
.section-sub-head {
  border-bottom: 1px solid $section-head-border-color;
  padding-bottom: 0.25rem;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
}
.section-mini-head {
  border-bottom: 1px solid $section-head-border-color;
  padding-bottom: 0.05rem;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
  font-size: 1.1rem;
}

.breadcrumb {
  li:last-of-type {
    a {
      color: $grey-dark;
      font-weight: bold;
      cursor: default;
    }
  }
}

table tbody {
  .is-selected {
    cursor: pointer;
  }
}

.margin-botton-10 {
  margin-bottom: 10px;
}

.margin-top-5 {
  margin-top: 5px;
}
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-15 {
  margin-top: 15px;
}
.margin-left-5 {
  margin-left: 5px;
}

.system-stamp {
  position: absolute;
  bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue